import { Network, CheckCircle2, Users, Coins, CalendarDays } from "lucide-react";
import { CELLS } from "@/constants/testIds";

const fmtMoney = (n) =>
  `$${(Number(n) || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const MONTHS = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

function StatCard({ icon: Icon, label, value, testid, children }) {
  return (
    <div className="border border-[#d9cfb8] bg-white px-4 py-3 flex items-start gap-3">
      <div className="mt-0.5 text-[#7a5b0f]">
        <Icon size={18} />
      </div>
      <div className="min-w-0">
        <div className="text-[9px] uppercase tracking-[0.18em] text-[#8b7e5e] leading-tight">
          {label}
        </div>
        <div data-testid={testid} className="text-lg font-semibold text-[#1c1a14] tabular-nums">
          {value}
        </div>
        {children}
      </div>
    </div>
  );
}

export default function CellsStats({
  totalCells,
  activeCells,
  totalMembers,
  annualOffering,
  monthOffering,
  year,
  setYear,
  month,
  setMonth,
  yearOptions,
}) {
  const selectCls =
    "border border-[#d9cfb8] bg-white px-1.5 py-0.5 text-[11px] rounded focus:border-[#c8a04a] focus:outline-none";
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-6">
      <StatCard icon={Network} label="Total de células" value={totalCells} testid={CELLS.statTotal} />
      <StatCard icon={CheckCircle2} label="Activas" value={activeCells} testid={CELLS.statActive} />
      <StatCard icon={Users} label="Miembros asignados" value={totalMembers} testid={CELLS.statMembers} />
      <StatCard
        icon={Coins}
        label={`Ofrenda anual ${year}`}
        value={fmtMoney(annualOffering)}
        testid={CELLS.statAnnualOffering}
      >
        <select
          data-testid={CELLS.yearSelect}
          value={year}
          onChange={(e) => setYear(Number(e.target.value))}
          className={`${selectCls} mt-1`}
        >
          {yearOptions.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </StatCard>
      <StatCard
        icon={CalendarDays}
        label={`Ofrenda del mes · ${MONTHS[month - 1]} ${year}`}
        value={fmtMoney(monthOffering)}
        testid={CELLS.statMonthOffering}
      >
        <select
          data-testid={CELLS.monthSelect}
          value={month}
          onChange={(e) => setMonth(Number(e.target.value))}
          className={`${selectCls} mt-1`}
        >
          {MONTHS.map((m, i) => (
            <option key={m} value={i + 1}>{m}</option>
          ))}
        </select>
      </StatCard>
    </div>
  );
}
